import React, {useState} from 'react';
import {FormularioPacientes} from '../Pacientes/FormularioPacientes';
import {Paciente} from '../Pacientes/Paciente';

export const FormularioUsuarios = ({idUsuario, setPantallaPerfil}) => {
	/* Creating a state object called Usuario and a function to set the state called setUsuario. */
	const [Usuario, setUsuario] = useState({
		nombre: '',
		apellidos: '',
		nombreUsuario: '',
		correo: '',
		contraseña: '',
		direccion: '',
		telefono1: '',
		telefono2: '',
	});
	const [PacienteB, setPaciente] = useState({
		fotoUsuario: '',
		nombreUsuario: 'Juan',
		idUsuario: '74320985',
		direccionUsuario: 'C/ Santa lucia 14',
		telefonoUsuario: '633333333',
		codPostUsuario: '10232',
		ShareCare: 'Activo',
	});

	const [viewPaciente, setViewPaciente] = useState(false);

	/**
	 * A function that handles the change of the input.
	 */
	const handleInpuntChange = (event) => {
		setUsuario({
			...Usuario,
			[event.target.name]: event.target.value,
		});
	};

	/* Creating a state object called SelectOption1 and a function to set the state called setSelectOption1. */
	const [SelectOption1, setSelectOption1] = useState('Soltero');

	/** * A function that handles the change of the radio button.
	 */
	const handleOptionChangeRadio1 = (event) => {
		setSelectOption1(event.target.value);
		handleInpuntChange(event);
	};

	/* Creating a state object called SelectOption2 and a function to set the state called setSelectOption2. */
	const [SelectOption2, setSelectOption2] = useState('Privado');

	/** * A function that handles the change of the radio button.
	 */
	const handleOptionChangeRadio2 = (event) => {
		setSelectOption2(event.target.value);
		handleInpuntChange(event);
	};

	/**
	 * A function that is called when the user clicks on the "Guardar Cambios" button.
	 */
	const guardarCambios = () => {
		console.log('Guradar cambios Usuario');
		setPantallaPerfil(false);
	};

	/**
	 * It sets the pantallaPerfil to false.
	 */
	const borrarCuenta = () => {
		console.log('borrar Usuario');
		setPantallaPerfil(false);
	};

	return (
		<>
			{!viewPaciente ? (
				<div>
					<div className='formularioUsuario'>
						<div
							className='buttonAtrasFormularioUsuario'
							onClick={() => setPantallaPerfil(false)}
						>
							Atrás
						</div>

						<div className='contentFormularioUsuario'>
							<div className='fotoUser'>
								<div className='centrador'>
									<img src='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images' />
								</div>
								<div className='centrador nombreID'>
									<div className='centrador nombreUsuarioForm'>
										{Usuario.nombre}
									</div>
									{/*<div className='IDUsuario'><b>ID : </b>{idUsuario}</div>*/}
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Nombre</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={Usuario.nombre}
										name={'nombre'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Apellidos</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={Usuario.apellidos}
										name={'apellidos'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Nombre de usuario</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={Usuario.nombreUsuario}
										name={'nombreUsuario'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Correo</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={Usuario.correo}
										name={'correo'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Contraseña</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={Usuario.contraseña}
										name={'contraseña'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Dirección</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={Usuario.direccion}
										name={'direccion'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Teléfono 1</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={Usuario.telefono1}
										name={'telefono1'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Teléfono 2</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={Usuario.telefono2}
										name={'telefono2'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
						</div>
						<div className='buttonGuardar'>
							<div
								className='button'
								Id='buttonGuardarFormUsu'
								onClick={guardarCambios}
							>
								<b>Guardar cambios</b>
							</div>
							<div
								className='button borrarCuenta'
								Id='button buttonBorrarFormUsu'
								onClick={borrarCuenta}
							>
								<b>Borrar Usuario</b>
							</div>
						</div>
					</div>

					<div className='usuarioAsociado'>
						<div className='listaUsurios'>
							<div className='centradorLeft titleHeadHistorialFacturas titleEnPacientes'>
								Paciente/s del Usuario
							</div>
							<Paciente
								fotPantallaPerileccionUsuario={PacienteB.direccionUsuario}
								nombreUsuario={PacienteB.nombreUsuario}
								idUsuario={PacienteB.idUsuario}
								direccionUsuario={PacienteB.direccionUsuario}
								telefonoUsuario={PacienteB.telefonoUsuario}
								codPostUsuario={PacienteB.codPostUsuario}
								ShareCare={PacienteB.ShareCare}
								abrirPerfil={() => {
									setViewPaciente(true);
								}}
							/>
							<Paciente
								fotPantallaPerileccionUsuario={PacienteB.direccionUsuario}
								nombreUsuario={PacienteB.nombreUsuario}
								idUsuario={PacienteB.idUsuario}
								direccionUsuario={PacienteB.direccionUsuario}
								telefonoUsuario={PacienteB.telefonoUsuario}
								codPostUsuario={PacienteB.codPostUsuario}
								ShareCare={PacienteB.ShareCare}
								abrirPerfil={() => {
									setViewPaciente(true);
								}}
							/>
							<Paciente
								fotPantallaPerileccionUsuario={PacienteB.direccionUsuario}
								nombreUsuario={PacienteB.nombreUsuario}
								idUsuario={PacienteB.idUsuario}
								direccionUsuario={PacienteB.direccionUsuario}
								telefonoUsuario={PacienteB.telefonoUsuario}
								codPostUsuario={PacienteB.codPostUsuario}
								ShareCare={PacienteB.ShareCare}
								abrirPerfil={() => {
									setViewPaciente(true);
								}}
							/>
							<div className='centradorRight'>
								<div
									className='button buttonAnadirPacientes'
									onClick={() => {
										setViewPaciente(true);
									}}
								>
									<b>Añadir paciente</b>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<FormularioPacientes
					idUsuario={Usuario.idUsuario}
					setPantallaPerfil={() => setViewPaciente(false)}
				/>
			)}
		</>
	);
};
